import script from './bar.vue_vue_type_script_lang.mjs';
export { default } from './bar.vue_vue_type_script_lang.mjs';
import { render } from './bar.vue_vue_type_template_id_2f63f10a_lang.mjs';

script.render = render;
script.__file = "packages/components/scrollbar/src/bar.vue";
//# sourceMappingURL=bar2.mjs.map
